import {
  Avatar,
  Box,
  Chip,
  Divider,
  Grid,
  Hidden,
  IconButton,
  Link,
  Tooltip,
  Typography
} from "@mui/material";
import { ArmyListLink, userDisplayName } from "../EventFunctions";
import { useState } from "react";
import {
  BCPAngleDown,
  BCPAngleUp,
  BCPEllipsisVertical
} from "../../../../components/icons/bcp/BCPIcons";
import { getEnvironmentVariable } from "../../../../global/environmentVariables";

const IS_WARMACHINE = getEnvironmentVariable("COMPANY_FLAG") === "wm";

export function SeatedRow(props) {
  const {
    organize,
    row,
    setPairing,

    setPairingPopUp,
    setPlayer,

    setOptionsAnchorEl2,
    setOptionsAnchorEl6
  } = props;

  if (organize) {
    return (
      <Grid
        item
        xs={12}
        sx={{
          mb: 1,
          border: "1px solid rgba(0, 0, 0, 0.12)",
          borderRadius: 1,
          boxShadow: 1
        }}
      >
        <Box
          onClick={(e) => {
            setPairing(row);
            setPairingPopUp(row);
          }}
          sx={{
            p: 1,
            mb: 1,
            border: "1px solid rgba(0, 0, 0, 0.12)",
            borderTopLeftRadius: "4px",
            borderTopRightRadius: "4px",
            boxShadow: 1,
            "&:hover": {
              cursor: "pointer"
            },

            backgroundColor: "#545b62",
            color: "#fff"
          }}
        >
          <Grid container spacing={1}>
            <Grid item xs={12} textAlign="center">
              <Typography>Table {row?.table}</Typography>
            </Grid>
          </Grid>
        </Box>
        {row?.seatedPlayers?.length > 0 &&
          row?.seatedPlayers.map((seatedPlayer, index) => {
            return (
              <SeatedPlayerRow
                key={index}
                organize={organize}
                seatedPairing={row}
                row={{
                  ...seatedPlayer,
                  id: seatedPlayer.playerId
                }}
                setPairing={setPairing}
                setPairingPopUp={setPairingPopUp}
                setPlayer={setPlayer}
                setOptionsAnchorEl6={setOptionsAnchorEl6}
              />
            );
          })}
      </Grid>
    );
  } else {
    return (
      <Grid
        item
        xs={12}
        sx={{
          mb: 1,
          border: "1px solid rgba(0, 0, 0, 0.12)",
          borderRadius: 1,
          boxShadow: 1
        }}
      >
        <Link
          href={`/game/${
            row?.pairingType ? row?.pairingType.toLowerCase() : "pairing"
          }/${row?.id}`}
          underline="none"
          sx={{ color: "inherit" }}
        >
          <Box
            sx={{
              p: 1,
              mb: 1,
              border: "1px solid rgba(0, 0, 0, 0.12)",
              borderTopLeftRadius: "4px",
              borderTopRightRadius: "4px",
              boxShadow: 1,

              backgroundColor: "#545b62",
              color: "#fff"
            }}
          >
            <Grid container spacing={1}>
              <Grid item xs={12} textAlign="center">
                <Typography>Table {row?.table}</Typography>
              </Grid>
            </Grid>
          </Box>

          {row?.seatedPlayers?.length > 0 &&
            row?.seatedPlayers.map((seatedPlayer, index) => {
              return (
                <SeatedPlayerRow
                  key={index}
                  organize={organize}
                  seatedPairing={row}
                  row={seatedPlayer}
                  setPairing={setPairing}
                  setPairingPopUp={setPairingPopUp}
                  setPlayer={setPlayer}
                  setOptionsAnchorEl2={setOptionsAnchorEl2}
                />
              );
            })}
        </Link>
      </Grid>
    );
  }
}

export function DoublesRow(props) {
  const {
    organize,
    row,
    setTeamPairing,
    setTeamPlayer,

    setPairingPopUp,

    setOptionsAnchorEl5
  } = props;

  if (organize) {
    return (
      <Grid
        item
        xs={12}
        onClick={(e) => {
          setTeamPairing(row);
          setPairingPopUp(row);
        }}
        sx={{
          p: 1,
          mb: 1,
          border: "1px solid rgba(0, 0, 0, 0.12)",
          borderRadius: "4px",
          boxShadow: 1,
          "&:hover": {
            cursor: "pointer"
          }
        }}
      >
        <Grid container spacing={1}>
          <Grid item sx={{ maxWidth: "50px" }}>
            <IconButton
              sx={{
                color: "info.contrastText",
                backgroundColor: "info.main",
                "&:hover": { backgroundColor: "info.dark" }
              }}
              onClick={(e) => {
                e.stopPropagation();
                setTeamPairing(row);
                setTeamPlayer(row["teamPlayer1"]);
                setOptionsAnchorEl5(e.currentTarget);
              }}
            >
              <BCPEllipsisVertical />
            </IconButton>
          </Grid>

          <Grid item xs sx={{ width: "auto" }}>
            <PlayerResult
              organize={organize}
              pairing={row}
              playerNo="teamPlayer1"
              doublesEvent
            />
          </Grid>
          <Grid
            item
            xs
            sx={{
              width: "16.66%",
              textAlign: "center"
            }}
          >
            <Typography>{row?.table}</Typography>
            {row?.isDone && (
              <Chip label="SUBMITTED" size="small" color="success" />
            )}
            {Boolean(
              !row?.isDone &&
                (row?.player1?.game?.gameResult !== undefined ||
                  row?.player2?.game?.gameResult !== undefined)
            ) && <Chip label="LIVE" size="small" color="info" />}
          </Grid>
          <Grid
            item
            xs
            sx={{
              width: "auto",
              textAlign: "right"
            }}
          >
            <PlayerResult
              organize={organize}
              pairing={row}
              playerNo="teamPlayer2"
              doublesEvent
            />
          </Grid>
          <Grid item sx={{ maxWidth: "50px" }}>
            <IconButton
              sx={{
                color: "info.contrastText",
                backgroundColor: "info.main",
                "&:hover": { backgroundColor: "info.dark" }
              }}
              onClick={(e) => {
                e.stopPropagation();
                setTeamPairing(row);
                setTeamPlayer(row["teamPlayer2"]);
                setOptionsAnchorEl5(e.currentTarget);
              }}
            >
              <BCPEllipsisVertical />
            </IconButton>
          </Grid>
        </Grid>
      </Grid>
    );
  } else {
    return (
      <Grid
        item
        xs={12}
        sx={{
          p: 1,
          mb: 1,
          border: "1px solid rgba(0, 0, 0, 0.12)",
          borderRadius: "4px",
          boxShadow: 1
        }}
      >
        <Grid container spacing={1}>
          <Grid item xs sx={{ width: "41.666667%" }}>
            <PlayerResult pairing={row} playerNo="teamPlayer1" doublesEvent />
          </Grid>
          <Grid item xs sx={{ width: "16.66%", textAlign: "center" }}>
            <Link
              href={`/game/${
                row?.pairingType ? row?.pairingType.toLowerCase() : "pairing"
              }/${row?.id}`}
              underline="none"
              sx={{ color: "inherit" }}
            >
              <Typography>{row?.table}</Typography>
              {row?.isDone && (
                <Chip label="SUBMITTED" size="small" color="success" />
              )}
              {Boolean(
                !row?.isDone &&
                  (row?.player1?.game?.gameResult !== undefined ||
                    row?.player2?.game?.gameResult !== undefined)
              ) && <Chip label="LIVE" size="small" color="info" />}
            </Link>
          </Grid>
          <Grid
            item
            xs
            sx={{
              width: "41.666667%",
              textAlign: "right"
            }}
          >
            <PlayerResult pairing={row} playerNo="teamPlayer2" doublesEvent />
          </Grid>
        </Grid>
      </Grid>
    );
  }
}

export function TeamRow(props) {
  const {
    organize,
    row,
    setPairing,
    setTeamPairing,
    setTeamPlayer,

    setPairingPopUp,
    setPlayer,

    setOptionsAnchorEl2,
    setOptionsAnchorEl5,
    event
  } = props;
  if (organize) {
    return (
      <Grid
        item
        xs={12}
        sx={{
          mb: 1,
          border: "1px solid rgba(0, 0, 0, 0.12)",
          borderRadius: 1,
          boxShadow: 1
        }}
      >
        <Box
          onClick={(e) => {
            setTeamPairing(row);
            setPairingPopUp(row);
          }}
          sx={{
            p: 1,
            mb: 1,
            border: "1px solid rgba(0, 0, 0, 0.12)",
            borderTopLeftRadius: "4px",
            borderTopRightRadius: "4px",
            boxShadow: 1,
            "&:hover": {
              cursor: "pointer"
            },

            backgroundColor: "#545b62",
            color: "#fff"
          }}
        >
          <Grid container spacing={1}>
            <Grid item sx={{ maxWidth: "50px" }}>
              <IconButton
                sx={{
                  color: "info.contrastText",
                  backgroundColor: "info.main",
                  "&:hover": { backgroundColor: "info.dark" }
                }}
                onClick={(e) => {
                  e.stopPropagation();
                  setTeamPairing(row);
                  setTeamPlayer(row["teamPlayer1"]);
                  setOptionsAnchorEl5(e.currentTarget);
                }}
              >
                <BCPEllipsisVertical />
              </IconButton>
            </Grid>

            <Grid item xs sx={{ width: "auto" }}>
              <PlayerResult
                organize={organize}
                pairing={row}
                playerNo="teamPlayer1"
              />
            </Grid>
            <Grid
              item
              xs
              sx={{
                width: "16.66%",
                textAlign: "center"
              }}
            >
              <Typography>{row?.table}</Typography>
              {row?.isDone && (
                <Chip label="SUBMITTED" size="small" color="success" />
              )}
              {Boolean(
                !row?.isDone &&
                  (row?.player1?.game?.gameResult !== undefined ||
                    row?.player2?.game?.gameResult !== undefined)
              ) && <Chip label="LIVE" size="small" color="info" />}
            </Grid>
            <Grid
              item
              xs
              sx={{
                width: "auto",
                textAlign: "right"
              }}
            >
              <PlayerResult
                organize={organize}
                pairing={row}
                playerNo="teamPlayer2"
              />
            </Grid>
            <Grid item sx={{ maxWidth: "50px" }}>
              <IconButton
                sx={{
                  color: "info.contrastText",
                  backgroundColor: "info.main",
                  "&:hover": { backgroundColor: "info.dark" }
                }}
                onClick={(e) => {
                  e.stopPropagation();
                  setTeamPairing(row);
                  setTeamPlayer(row["teamPlayer2"]);
                  setOptionsAnchorEl5(e.currentTarget);
                }}
              >
                <BCPEllipsisVertical />
              </IconButton>
            </Grid>
          </Grid>
        </Box>
        {row?.pairings?.length > 0 &&
          row?.pairings.map((pairing, index) => {
            return (
              <PlayerRow
                key={index}
                organize={organize}
                row={pairing}
                setPairing={setPairing}
                setPairingPopUp={setPairingPopUp}
                setPlayer={setPlayer}
                setOptionsAnchorEl2={setOptionsAnchorEl2}
                team
                event={event}
              />
            );
          })}
      </Grid>
    );
  } else {
    return (
      <Grid
        item
        xs={12}
        sx={{
          mb: 1,
          border: "1px solid rgba(0, 0, 0, 0.12)",
          borderRadius: 1,
          boxShadow: 1
        }}
      >
        <Box
          sx={{
            p: 1,
            mb: 1,
            border: "1px solid rgba(0, 0, 0, 0.12)",
            borderTopLeftRadius: "4px",
            borderTopRightRadius: "4px",
            boxShadow: 1,

            backgroundColor: "#545b62",
            color: "#fff"
          }}
        >
          <Grid container spacing={1}>
            <Grid item xs sx={{ width: "41.666667%" }}>
              <PlayerResult pairing={row} playerNo="teamPlayer1" />
            </Grid>
            <Grid item xs sx={{ width: "16.66%", textAlign: "center" }}>
              <Link
                href={`/game/${
                  row?.pairingType ? row?.pairingType.toLowerCase() : "pairing"
                }/${row?.id}`}
                underline="none"
                sx={{ color: "inherit" }}
              >
                <Typography>{row?.table}</Typography>
                {row?.isDone && (
                  <Chip label="SUBMITTED" size="small" color="success" />
                )}
                {Boolean(
                  !row?.isDone &&
                    (row?.player1?.game?.gameResult !== undefined ||
                      row?.player2?.game?.gameResult !== undefined)
                ) && <Chip label="LIVE" size="small" color="info" />}
              </Link>
            </Grid>
            <Grid
              item
              xs
              sx={{
                width: "41.666667%",
                textAlign: "right"
              }}
            >
              <PlayerResult pairing={row} playerNo="teamPlayer2" />
            </Grid>
          </Grid>
        </Box>

        {row?.pairings?.length > 0 &&
          row?.pairings.map((pairing, index) => {
            return (
              <PlayerRow
                key={index}
                row={pairing}
                setPairing={setPairing}
                setPairingPopUp={setPairingPopUp}
                setPlayer={setPlayer}
                setOptionsAnchorEl2={setOptionsAnchorEl2}
                event={event}
                team
              />
            );
          })}
      </Grid>
    );
  }
}

export function PlayerRow(props) {
  const { organize, row, setPlayer, showOverall, placingDict, event, league } =
    props;

  const [expand, setExpand] = useState(false);

  const isManuallyPlaced = Boolean(
    row?.manualPlacing || row?.manualHobbyPlacing || row?.manualOverallPlacing
  );

  if (row?.isPod) {
    if (showOverall) return <></>;
    return (
      <Grid
        item
        xs={12}
        hover
        sx={{
          minHeight: "30px",
          height: "30px",
          p: "4px"
        }}
      >
        {row?.label !== undefined
          ? row?.label
          : row?.podNum
            ? `Bracket ${row?.podNum}`
            : "Swiss Bracket"}
        <Divider sx={{ mb: 1, mt: 1 }} />
      </Grid>
    );
  }

  var rankingPoints = "";
  if (placingDict[row?.id]) {
    rankingPoints = league?.jascoLeague
      ? parseInt(placingDict[row?.id].jascoPoints)
      : league?.solforgeLeague
        ? parseInt(placingDict[row?.id].solforgePoints)
        : parseFloat(
            league?.texasMasters
              ? placingDict[row?.id].TexasMastersPoints || 0
              : league?.itc
                ? placingDict[row?.id].ITCPoints || 0
                : placingDict[row?.id].BCPPoints || 0
          ).toFixed(2);
  }

  const softScores = organize
    ? Object.values(row?.softScores || {})
    : Object.values(row?.softScores || {})?.filter((el) => el.overall);

  if (getEnvironmentVariable("COMPANY_FLAG") === "bcp") {
    if (event?.numberOfRounds === 0 && showOverall) {
      return (
        <Grid
          key={row?.id}
          item
          xs={12}
          onClick={() => {
            setPlayer(row);
          }}
          sx={{
            p: 1,
            ...(isManuallyPlaced && {
              background:
                "linear-gradient(45deg, rgba(102, 182, 255, 0.08) 0%, rgba(102, 182, 255, 0.15) 100%)",
              borderLeft: 4,
              borderLeftColor: "secondary.main",
              boxShadow: "0 2px 4px rgba(102, 182, 255, 0.1)"
            }),
            "&:hover": {
              cursor: "pointer"
            }
          }}
        >
          <Grid container spacing={1} sx={{ flexWrap: "nowrap" }}>
            <Grid item sx={{ flex: 1, maxWidth: "50px" }}>
              <Typography variant="body1" gutterBottom>
                {row?.overall_placing < 10
                  ? "0" + row?.overall_placing
                  : row?.overall_placing}
              </Typography>

              {league && (
                <Typography variant="caption" paragraph sx={{ mb: 0 }}>
                  {rankingPoints}
                </Typography>
              )}
            </Grid>
            <Grid item sx={{ flex: 1 }} xs={12}>
              <Hidden mdUp>
                {row?.name && (
                  <Typography
                    variant="body1"
                    gutterBottom
                    sx={{ overflowX: "hidden" }}
                  >
                    {row?.name}
                  </Typography>
                )}
                {!row?.name && (row?.firstName || row?.user?.firstName) && (
                  <Typography variant="body1" gutterBottom>
                    {row?.firstName || row?.user?.firstName || "--------"}
                  </Typography>
                )}
                {!row?.name && (row?.lastName || row?.user?.lastName) && (
                  <Typography variant="body1" gutterBottom>
                    {row?.lastName || row?.user?.lastName || "--------"}
                  </Typography>
                )}
                {row?.extendedGroupName && (
                  <Typography variant="body1" gutterBottom>
                    {row?.extendedGroupName}
                  </Typography>
                )}
                {expand && (row?.team?.name || row?.teamName) && (
                  <>
                    <Typography
                      variant="h6"
                      color="text.secondary"
                      gutterBottom
                    >
                      Team Name
                    </Typography>
                    <Typography variant="body1" gutterBottom>
                      {row?.team?.name || row?.teamName}
                    </Typography>
                  </>
                )}
                {(row?.army?.name || row?.armyName || row?.faction?.name) &&
                  (organize || !event.hideLists) &&
                  event?.gameSystem?.hasFactions && (
                    <Typography variant="body2" gutterBottom>
                      {row?.army?.name || row?.armyName || row?.faction?.name}
                    </Typography>
                  )}
                {(row?.characterName ||
                  row?.character?.name ||
                  row?.subFactionName ||
                  row?.subFaction?.name) &&
                  (organize || !event.hideLists) && (
                    <Typography variant="body2" gutterBottom>
                      {row?.characterName ||
                        row?.character?.name ||
                        row?.subFactionName ||
                        row?.subFaction?.name}
                    </Typography>
                  )}
                {!event.hideLists && (
                  <Typography variant="body2" gutterBottom>
                    <ArmyListLink event={event} player={row} dense />
                  </Typography>
                )}

                {row?.overall_metrics
                  ?.filter((metric) => metric.name === "Overall Score")
                  ?.map((metric, index) => {
                    return (
                      <Typography
                        key={index}
                        variant="caption"
                        paragraph
                        sx={{ mb: 0, textTransform: "uppercase" }}
                      >
                        {metric.name} {metric?.value}
                      </Typography>
                    );
                  })}

                {expand && softScores?.length > 0 && (
                  <>
                    <Typography
                      variant="caption"
                      paragraph
                      sx={{ mt: 1, mb: 0, textTransform: "uppercase" }}
                    >
                      Soft Scores
                    </Typography>
                    {softScores?.map((softScore, index) => {
                      return (
                        <Typography
                          key={index}
                          variant="caption"
                          color="text.secondary"
                          sx={{ mb: 0, textTransform: "uppercase" }}
                          paragraph
                        >
                          {softScore?.name} {softScore?.value}
                        </Typography>
                      );
                    })}
                  </>
                )}
              </Hidden>
              <Hidden mdDown>
                {(row?.name ||
                  row?.firstName ||
                  row?.lastName ||
                  row?.user?.firstName ||
                  row?.user?.lastName) && (
                  <Typography
                    variant="body1"
                    gutterBottom
                    sx={{ overflowX: "hidden" }}
                  >
                    {`${
                      row?.name
                        ? `${row?.name}${
                            row?.teamName || row?.team?.name
                              ? ` - ${row?.teamName || row?.team?.name}`
                              : ""
                          }`
                        : `${row?.firstName || row?.user?.firstName || ""} ${
                            row?.lastName || row?.user?.lastName || ""
                          }${
                            row?.teamName || row?.team?.name
                              ? ` - ${row?.teamName || row?.team?.name}`
                              : ""
                          }`
                    }`}
                  </Typography>
                )}
                {row?.extendedGroupName && (
                  <Typography
                    variant="body1"
                    gutterBottom
                    sx={{ overflowX: "hidden" }}
                  >
                    {row?.extendedGroupName}
                  </Typography>
                )}
                {(organize || !event.hideLists) &&
                  (row?.armyName ||
                    row?.army?.name ||
                    row?.faction?.name ||
                    row?.characterName ||
                    row?.character?.name ||
                    row?.subFactionName ||
                    row?.subFaction?.name) && (
                    <Typography variant="body2" gutterBottom>
                      {`${
                        row?.armyName ||
                        row?.army?.name ||
                        row?.faction?.name ||
                        ""
                      }${
                        row?.characterName ||
                        row?.character?.name ||
                        row?.subFactionName ||
                        row?.subFaction?.name
                          ? row?.armyName || row?.faction?.name
                            ? " - " +
                              (row?.characterName ||
                                row?.character?.name ||
                                row?.subFactionName ||
                                row?.subFaction?.name)
                            : row?.characterName ||
                              row?.character?.name ||
                              row?.subFactionName ||
                              row?.subFaction?.name
                          : ""
                      }`}
                    </Typography>
                  )}
                {!event.hideLists && (
                  <Typography variant="body2" gutterBottom>
                    <ArmyListLink event={event} player={row} dense />
                  </Typography>
                )}

                {row?.overall_metrics
                  ?.filter((metric) => metric.name === "Overall Score")
                  ?.map((metric, index) => {
                    return (
                      <Typography
                        key={index}
                        variant="caption"
                        paragraph
                        sx={{ mb: 0, textTransform: "uppercase" }}
                      >
                        {metric.name} {metric?.value}
                      </Typography>
                    );
                  })}

                {expand && softScores?.length > 0 && (
                  <>
                    <Typography
                      variant="caption"
                      paragraph
                      sx={{ mt: 1, mb: 0, textTransform: "uppercase" }}
                    >
                      Soft Scores
                    </Typography>
                    {softScores?.map((softScore, index) => {
                      return (
                        <Typography
                          key={index}
                          variant="caption"
                          color="text.secondary"
                          sx={{ mb: 0, textTransform: "uppercase" }}
                          paragraph
                        >
                          {softScore?.name} {softScore?.value}
                        </Typography>
                      );
                    })}
                  </>
                )}
              </Hidden>
            </Grid>
            <Grid item sx={{ maxWidth: "40px" }}>
              <IconButton
                onClick={(e) => {
                  e.stopPropagation();
                  setExpand(!expand);
                }}
              >
                {expand ? <BCPAngleUp /> : <BCPAngleDown />}
              </IconButton>
            </Grid>
          </Grid>
          <Divider sx={{ mb: 1, mt: 1 }} />
        </Grid>
      );
    }
    return (
      <Grid
        key={row?.id}
        item
        xs={12}
        onClick={() => {
          setPlayer(row);
        }}
        sx={{
          p: 1,
          ...(isManuallyPlaced && {
            background:
              "linear-gradient(45deg, rgba(102, 182, 255, 0.08) 0%, rgba(102, 182, 255, 0.15) 100%)",
            borderLeft: 4,
            borderLeftColor: "secondary.main",
            boxShadow: "0 2px 4px rgba(102, 182, 255, 0.1)"
          }),
          "&:hover": {
            cursor: "pointer"
          }
        }}
      >
        <Grid container spacing={1} sx={{ flexWrap: "nowrap" }}>
          <Grid item sx={{ flex: 1, maxWidth: "70px" }}>
            {isManuallyPlaced ? (
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center"
                }}
              >
                <Tooltip title="Manually placed by the Organizer">
                  <Typography
                    variant="body1"
                    color="secondary.main"
                    gutterBottom
                  >
                    {showOverall
                      ? `${
                          row?.overall_placing < 10
                            ? "0" + row?.overall_placing
                            : row?.overall_placing
                        }`
                      : `${row?.placing < 10 ? "0" + row?.placing : row?.placing}`}
                  </Typography>
                </Tooltip>
                <Chip
                  label="MANUAL"
                  sx={{
                    backgroundColor: "secondary.main",
                    color: "secondary.contrastText",
                    fontSize: "0.6rem",
                    height: "20px",
                    fontWeight: "bold",
                    minWidth: "65px",
                    "& .MuiChip-label": {
                      px: 1
                    }
                  }}
                />
              </Box>
            ) : (
              <Typography variant="body1" gutterBottom>
                {showOverall
                  ? `${
                      row?.overall_placing < 10
                        ? "0" + row?.overall_placing
                        : row?.overall_placing
                    }`
                  : `${row?.placing < 10 ? "0" + row?.placing : row?.placing}`}
              </Typography>
            )}

            {league && (
              <Typography variant="caption" paragraph sx={{ mb: 0 }}>
                {rankingPoints}
              </Typography>
            )}
          </Grid>
          <Grid item sx={{ flex: 1 }} xs={12}>
            <Hidden mdUp>
              {row?.name && (
                <Typography
                  variant="body1"
                  gutterBottom
                  sx={{ overflowX: "hidden" }}
                >
                  {row?.name}
                </Typography>
              )}
              {!row?.name && (row?.firstName || row?.user?.firstName) && (
                <Typography variant="body1" gutterBottom>
                  {row?.firstName || row?.user?.firstName || "--------"}
                </Typography>
              )}
              {!row?.name && (row?.lastName || row?.user?.lastName) && (
                <Typography variant="body1" gutterBottom>
                  {row?.lastName || row?.user?.lastName || "--------"}
                </Typography>
              )}
              {row?.extendedGroupName && (
                <Typography variant="body1" gutterBottom>
                  {row?.extendedGroupName}
                </Typography>
              )}
              {expand && (row?.team?.name || row?.teamName) && (
                <>
                  <Typography variant="h6" color="text.secondary" gutterBottom>
                    Team Name
                  </Typography>
                  <Typography variant="body1" gutterBottom>
                    {row?.team?.name || row?.teamName}
                  </Typography>
                </>
              )}
              {(row?.army?.name || row?.armyName || row?.faction?.name) &&
                (organize || !event.hideLists) &&
                event?.gameSystem?.hasFactions && (
                  <Typography variant="body2" gutterBottom>
                    {row?.army?.name || row?.armyName || row?.faction?.name}
                  </Typography>
                )}
              {(row?.characterName ||
                row?.character?.name ||
                row?.subFactionName ||
                row?.subFaction?.name) &&
                (organize || !event.hideLists) && (
                  <Typography variant="body2" gutterBottom>
                    {row?.characterName ||
                      row?.character?.name ||
                      row?.subFactionName ||
                      row?.subFaction?.name}
                  </Typography>
                )}
              {expand && !event.hideLists && (
                <Typography variant="body2" gutterBottom>
                  <ArmyListLink event={event} player={row} dense />
                </Typography>
              )}
              {showOverall ? (
                <>
                  {row?.overall_metrics
                    ?.filter((metric) => metric.name !== "Random")
                    ?.map((metric, index) => {
                      return (
                        <Typography
                          key={index}
                          variant="caption"
                          paragraph
                          sx={{ mb: 0, textTransform: "uppercase" }}
                        >
                          {metric.modified ? (
                            <Tooltip
                              componentsProps={{
                                tooltip: { sx: { maxWidth: "90vw" } }
                              }}
                              title={
                                <Box>
                                  <Typography
                                    variant="caption"
                                    sx={{ display: "block" }}
                                  >
                                    This metric has been modified by the
                                    organizer.
                                  </Typography>
                                </Box>
                              }
                            >
                              {metric.name} {metric?.value}
                            </Tooltip>
                          ) : (
                            <>
                              {metric.name} {metric?.value}
                            </>
                          )}
                        </Typography>
                      );
                    })}
                  {expand && (
                    <Typography
                      variant="caption"
                      paragraph
                      sx={{ mb: 0, minHeight: "20px" }}
                    >
                      {expand && "Record: "}
                      {row?.recordJSX}
                    </Typography>
                  )}
                </>
              ) : (
                <Typography
                  variant="caption"
                  paragraph
                  sx={{ mb: 0, minHeight: "20px" }}
                >
                  {expand && "Record: "}
                  {row?.recordJSX}
                </Typography>
              )}
              {expand &&
                row?.total_metrics
                  ?.filter((metric) => metric.name !== "Random")
                  ?.map((metric, index) => {
                    return (
                      <Typography
                        key={index}
                        variant="caption"
                        color={
                          metric.modified ? "warning.main" : "text.secondary"
                        }
                        sx={{ mb: 0, textTransform: "uppercase" }}
                        paragraph
                      >
                        {metric.modified ? (
                          <Tooltip
                            componentsProps={{
                              tooltip: { sx: { maxWidth: "90vw" } }
                            }}
                            title={
                              <Box>
                                <Typography
                                  variant="caption"
                                  sx={{ display: "block" }}
                                >
                                  This metric has been modified by the
                                  organizer.
                                </Typography>
                              </Box>
                            }
                          >
                            {metric.name} {metric?.value}
                          </Tooltip>
                        ) : (
                          <>
                            {metric.name} {metric?.value}
                          </>
                        )}
                      </Typography>
                    );
                  })}

              {expand && softScores?.length > 0 && (
                <>
                  <Typography
                    variant="caption"
                    paragraph
                    sx={{ mt: 1, mb: 0, textTransform: "uppercase" }}
                  >
                    Soft Scores
                  </Typography>
                  {softScores?.map((softScore, index) => {
                    return (
                      <Typography
                        key={index}
                        variant="caption"
                        color="text.secondary"
                        sx={{ mb: 0, textTransform: "uppercase" }}
                        paragraph
                      >
                        {softScore?.name} {softScore?.value}
                      </Typography>
                    );
                  })}
                </>
              )}
            </Hidden>
            <Hidden mdDown>
              {(row?.name ||
                row?.firstName ||
                row?.lastName ||
                row?.user?.firstName ||
                row?.user?.lastName) && (
                <Typography
                  variant="body1"
                  gutterBottom
                  sx={{ overflowX: "hidden" }}
                >
                  {`${
                    row?.name
                      ? `${row?.name}${
                          row?.teamName || row?.team?.name
                            ? ` - ${row?.teamName || row?.team?.name}`
                            : ""
                        }`
                      : `${row?.firstName || row?.user?.firstName || ""} ${
                          row?.lastName || row?.user?.lastName || ""
                        }${
                          row?.teamName || row?.team?.name
                            ? ` - ${row?.teamName || row?.team?.name}`
                            : ""
                        }`
                  }`}
                </Typography>
              )}
              {row?.extendedGroupName && (
                <Typography
                  variant="body1"
                  gutterBottom
                  sx={{ overflowX: "hidden" }}
                >
                  {row?.extendedGroupName}
                </Typography>
              )}
              {(organize || !event.hideLists) &&
                (row?.armyName ||
                  row?.army?.name ||
                  row?.faction?.name ||
                  row?.characterName ||
                  row?.character?.name ||
                  row?.subFactionName ||
                  row?.subFaction?.name) && (
                  <Typography variant="body2" gutterBottom>
                    {`${
                      row?.armyName ||
                      row?.army?.name ||
                      row?.faction?.name ||
                      ""
                    }${
                      row?.characterName ||
                      row?.character?.name ||
                      row?.subFactionName ||
                      row?.subFaction?.name
                        ? row?.armyName || row?.faction?.name
                          ? " - " +
                            (row?.characterName ||
                              row?.character?.name ||
                              row?.subFactionName ||
                              row?.subFaction?.name)
                          : row?.characterName ||
                            row?.character?.name ||
                            row?.subFactionName ||
                            row?.subFaction?.name
                        : ""
                    }`}
                  </Typography>
                )}
              {expand && !event.hideLists && (
                <Typography variant="body2" gutterBottom>
                  <ArmyListLink event={event} player={row} dense />
                </Typography>
              )}
              {showOverall ? (
                <>
                  {row?.overall_metrics
                    ?.filter((metric) => metric.name !== "Random")
                    ?.map((metric, index) => {
                      return (
                        <Typography
                          key={index}
                          variant="caption"
                          color={
                            metric.modified ? "warning.main" : "text.secondary"
                          }
                          paragraph
                          sx={{ mb: 0, textTransform: "uppercase" }}
                        >
                          {metric.modified ? (
                            <Tooltip
                              componentsProps={{
                                tooltip: { sx: { maxWidth: "90vw" } }
                              }}
                              title={
                                <Box>
                                  <Typography
                                    variant="caption"
                                    sx={{ display: "block" }}
                                  >
                                    This metric has been modified by the
                                    organizer.
                                  </Typography>
                                </Box>
                              }
                            >
                              {metric.name} {metric?.value}
                            </Tooltip>
                          ) : (
                            <>
                              {metric.name} {metric?.value}
                            </>
                          )}
                        </Typography>
                      );
                    })}
                  {expand && (
                    <Typography
                      variant="caption"
                      paragraph
                      sx={{ mb: 0, minHeight: "20px" }}
                    >
                      {expand && "Record: "}
                      {row?.recordJSX}
                    </Typography>
                  )}
                </>
              ) : (
                <Typography
                  variant="caption"
                  paragraph
                  sx={{ mb: 0, minHeight: "20px" }}
                >
                  {row?.recordJSX}
                </Typography>
              )}
              {expand &&
                row?.total_metrics
                  ?.filter((metric) => metric.name !== "Random")
                  ?.map((metric, index) => {
                    return (
                      <Typography
                        key={index}
                        variant="caption"
                        color={
                          metric.modified ? "warning.main" : "text.secondary"
                        }
                        sx={{ mb: 0, textTransform: "uppercase" }}
                        paragraph
                      >
                        {metric.modified ? (
                          <Tooltip
                            componentsProps={{
                              tooltip: { sx: { maxWidth: "90vw" } }
                            }}
                            title={
                              <Box>
                                <Typography
                                  variant="caption"
                                  sx={{ display: "block" }}
                                >
                                  This metric has been modified by the
                                  organizer.
                                </Typography>
                              </Box>
                            }
                          >
                            {metric.name} {metric?.value}
                          </Tooltip>
                        ) : (
                          <>
                            {metric.name} {metric?.value}
                          </>
                        )}
                      </Typography>
                    );
                  })}

              {expand && softScores?.length > 0 && (
                <>
                  <Typography
                    variant="caption"
                    paragraph
                    sx={{ mt: 1, mb: 0, textTransform: "uppercase" }}
                  >
                    Soft Scores
                  </Typography>
                  {softScores?.map((softScore, index) => {
                    return (
                      <Typography
                        key={index}
                        variant="caption"
                        color="text.secondary"
                        sx={{ mb: 0, textTransform: "uppercase" }}
                        paragraph
                      >
                        {softScore?.name} {softScore?.value}
                      </Typography>
                    );
                  })}
                </>
              )}
            </Hidden>
          </Grid>
          <Grid item sx={{ maxWidth: "40px" }}>
            <IconButton
              onClick={(e) => {
                e.stopPropagation();
                setExpand(!expand);
              }}
            >
              {expand ? <BCPAngleUp /> : <BCPAngleDown />}
            </IconButton>
          </Grid>
        </Grid>
        <Divider sx={{ mb: 1, mt: 1 }} />
      </Grid>
    );
  }

  return (
    <Grid
      item
      xs={12}
      onClick={() => {
        setPlayer(row);
      }}
      sx={{
        p: 1,
        mb: 1,
        border: "1px solid rgba(0, 0, 0, 0.12)",
        borderRadius: 1,
        ...(isManuallyPlaced && {
          background:
            "linear-gradient(45deg, rgba(102, 182, 255, 0.08) 0%, rgba(102, 182, 255, 0.15) 100%)",
          borderLeft: 4,
          borderLeftColor: "secondary.main",
          boxShadow: "0 2px 4px rgba(102, 182, 255, 0.1)"
        }),
        "&:hover": {
          cursor: "pointer"
        }
      }}
    >
      <Grid container spacing={1}>
        <Grid item>
          {isManuallyPlaced ? (
            <Box sx={{ position: "relative" }}>
              <Tooltip title="Manually placed by the Organizer">
                <Avatar
                  sx={{
                    bgcolor: "secondary.main",
                    color: "secondary.contrastText",
                    width: 50,
                    height: 50
                  }}
                >
                  {showOverall ? row?.overall_placing : row?.placing}
                </Avatar>
              </Tooltip>
              <Chip
                label="MANUAL"
                size="small"
                sx={{
                  position: "absolute",
                  top: -8,
                  right: -8,
                  backgroundColor: "secondary.main",
                  color: "secondary.contrastText",
                  fontSize: "0.6rem",
                  height: "16px",
                  fontWeight: "bold",
                  "& .MuiChip-label": {
                    px: 0.5
                  }
                }}
              />
            </Box>
          ) : (
            <Avatar
              sx={{
                bgcolor: "primary.main",
                color: "primary.contrastText",
                width: 50,
                height: 50
              }}
            >
              {showOverall ? row?.overall_placing : row?.placing}
            </Avatar>
          )}
        </Grid>
        {getEnvironmentVariable("COMPANY_FLAG") === "solforge" && (
          <Grid item>
            <Avatar
              alt={
                row?.name
                  ? row?.name
                  : `${row?.user?.firstName} ${row?.user?.lastName}`
              }
              src={row?.user?.profileImageUrl}
              sx={{ width: 50, height: 50, mr: 1 }}
            />
          </Grid>
        )}

        <Grid item sx={{ flexGrow: "1", maxWidth: "calc(100% - 124px)" }}>
          <Typography variant="body1">
            {row?.name
              ? `${row?.name}${
                  row?.team?.name || row?.teamName
                    ? ` - ${row?.team?.name || row?.teamName}`
                    : ""
                }`
              : `${row?.firstName || row?.user?.firstName || ""} ${
                  row?.lastName || row?.user?.lastName || ""
                } ${row?.teamName || row?.team?.name || ""}`.trim()}
          </Typography>

          {(organize || !event.hideLists) && (
            <Typography
              variant="caption"
              paragraph
              sx={{
                mb: 0,
                fontStyle: "italic"
              }}
            >
              {getEnvironmentVariable("COMPANY_FLAG") === "solforge" ? (
                <>
                  {row?.armyListSolforge?.myDecks?.length > 0 && (
                    <Link
                      href={`${
                        getEnvironmentVariable("HEADER_SOLFORGE_URL") || ""
                      }/fused/${row?.armyListSolforge.id}`}
                      underline="none"
                      target="_blank"
                    >
                      {row?.armyListSolforge.myDecks
                        .map((deck) => deck.name)
                        .join(" - ")}
                    </Link>
                  )}
                </>
              ) : (
                <>
                  {IS_WARMACHINE && row?.faction?.parentFaction?.name
                    ? `${row?.faction?.parentFaction?.name} - `
                    : ""}
                  {row?.army?.name || row?.faction?.name}
                  {row?.subFaction?.name ? ` - ${row?.subFaction.name}` : ""}
                </>
              )}
            </Typography>
          )}
        </Grid>
        <Grid
          item
          sx={{
            textAlign: "right",
            maxWidth: ["100%", "100%", "33.333333%", "25%"],
            minWidth: ["100%", "100%", "33.333333%", "25%"]
          }}
        >
          {showOverall && row?.overall_metrics?.length ? (
            row?.overall_metrics.map((metric, index) => (
              <Typography
                key={index}
                variant="caption"
                paragraph
                sx={{ mb: 0, minHeight: "20px" }}
              >
                {metric.name} {metric?.value}
              </Typography>
            ))
          ) : row?.pod_games?.length && row?.pod_metrics?.length ? (
            row?.pod_metrics.map((metric, index) => (
              <Typography
                key={index}
                variant="caption"
                paragraph
                sx={{ mb: 0, minHeight: "20px" }}
              >
                {metric.name} {metric?.value}
              </Typography>
            ))
          ) : (
            <></>
          )}
          <Typography
            variant="caption"
            paragraph
            sx={{ mb: 0, minHeight: "20px" }}
          >
            {row?.recordJSX}
          </Typography>
          {row?.total_metrics &&
            row?.total_metrics.map((metric, index) => (
              <Typography
                key={index}
                variant="caption"
                paragraph
                sx={{ mb: 0, minHeight: "20px" }}
              >
                {metric.name} {metric?.value}
              </Typography>
            ))}

          {league && (
            <Typography variant="caption" paragraph sx={{ mb: 0 }}>
              Ranking Points: {rankingPoints}
            </Typography>
          )}
        </Grid>
      </Grid>
    </Grid>
  );
}

export function PlayerResultInRows(props) {
  const { event, playerNo, pairing, doublesEvent, organize } = props;
  const player = pairing[playerNo];
  const game = pairing[`${playerNo.replace("teamPlayer", "player")}Game`];

  var result = "";
  var color = "";
  if (game?.gameResult >= 2) {
    result = "Win";
    color = "success";
  } else if (game?.gameResult === 1) {
    result = "Draw";
    color = "info";
  } else {
    result = "Loss";
    color = "error";
  }
  if (!doublesEvent && playerNo.startsWith("teamPlayer")) {
    color = "#fff";
  }

  const name = player?.name
    ? player.name
    : player?.id
      ? userDisplayName(
          player?.firstName || player?.user?.firstName,
          player?.lastName || player?.user?.lastName
        )
      : "--------";

  const SolforgeDisplay = () => {
    return (
      <Grid
        container
        spacing={1}
        alignItems="center"
        sx={{
          "& .MuiTypography-root": { fontSize: "16px", m: 0 },
          "& .MuiTypography-root:not(:first-child)": { fontSize: "14px", m: 0 }
        }}
      >
        {playerNo === "player1" && (
          <Grid item sx={{ maxWidth: "40px" }}>
            <Avatar
              alt={name}
              src={player.profileImageUrl}
              sx={{ width: 30, height: 30 }}
            />
          </Grid>
        )}
        <Grid item sx={{ flex: 1 }}>
          <PlayerResultDisplay />
        </Grid>
        {playerNo === "player2" && (
          <Grid item sx={{ maxWidth: "40px", textAlign: "right" }}>
            <Avatar
              alt={name}
              src={player.profileImageUrl}
              sx={{ width: 30, height: 30 }}
            />
          </Grid>
        )}
      </Grid>
    );
  };

  const PlayerResultDisplay = () => {
    return (
      <>
        {playerNo.startsWith("teamPlayer") && (
          <Typography variant="body1" gutterBottom>
            {player.name || "--------"}
          </Typography>
        )}
        {!playerNo.startsWith("teamPlayer") && (
          <>
            {(player?.firstName || player?.user?.firstName) && (
              <Typography variant="body1" gutterBottom>
                {player?.firstName || player?.user?.firstName || "--------"}
              </Typography>
            )}
            {(player?.lastName || player?.user?.lastName) && (
              <Typography variant="body1" gutterBottom>
                {player?.lastName || player?.user?.lastName || "--------"}
              </Typography>
            )}
            {!event.hideLists && event?.gameSystem?.hasFactions && (
              <Typography variant="body2" gutterBottom>
                {player.army?.name || player.armyName || "--------"}
              </Typography>
            )}
            {!event.hideLists && event?.gameSystem?.hasSubFactions && (
              <Typography variant="body2" gutterBottom>
                {player.subFaction?.name || player.subFactionName || "--------"}
              </Typography>
            )}
          </>
        )}

        {game?.gameResult !== undefined && (
          <Typography
            variant="body2"
            gutterBottom
            sx={{ color: `${color}.main` }}
          >{`${result}${
            game?.gamePoints !== undefined ? `: ${game.gamePoints}` : ""
          }`}</Typography>
        )}
        {!event.hideLists && (
          <Typography variant="body2" gutterBottom>
            <ArmyListLink event={event} player={player} dense />
          </Typography>
        )}
      </>
    );
  };

  if (organize) {
    return getEnvironmentVariable("COMPANY_FLAG") === "solforge" ? (
      <SolforgeDisplay />
    ) : (
      <PlayerResultDisplay />
    );
  } else {
    return (
      <Link
        href={`/game/${
          pairing?.pairingType ? pairing.pairingType.toLowerCase() : "pairing"
        }/${pairing.id}`}
        underline="none"
        sx={{ color: "inherit" }}
      >
        {getEnvironmentVariable("COMPANY_FLAG") === "solforge" ? (
          <SolforgeDisplay />
        ) : (
          <PlayerResultDisplay />
        )}
      </Link>
    );
  }
}

export function SeatedPlayerRow(props) {
  const {
    organize,
    row,
    seatedPairing,
    setPairing,
    setPairingPopUp,
    setPlayer,
    setOptionsAnchorEl6
  } = props;

  const isManuallyPlaced = Boolean(
    row?.manualPlacing || row?.manualHobbyPlacing || row?.manualOverallPlacing
  );

  const game = seatedPairing?.games?.[row?.playerId];

  var result = "";
  var color = "";

  const playerName = row?.name
    ? row?.name
    : row?.id
      ? userDisplayName(
          row?.firstName || row?.user?.firstName,
          row?.lastNam || row?.user?.lastName
        )
      : "--------";

  if (game?.gameResult >= 2) {
    result = "Win";
    color = "success";
  } else if (game?.gameResult === 1) {
    result = "Draw";
    color = "info";
  } else {
    result = "Loss";
    color = "error";
  }

  if (organize) {
    return (
      <Grid
        item
        xs={12}
        onClick={(e) => {
          setPairing(seatedPairing);
          setPairingPopUp(seatedPairing);
        }}
        sx={{
          p: 1,
          borderBottom: "1px solid rgba(0, 0, 0, 0.12)",
          ...(isManuallyPlaced && {
            background:
              "linear-gradient(45deg, rgba(102, 182, 255, 0.08) 0%, rgba(102, 182, 255, 0.15) 100%)",
            borderLeft: 4,
            borderLeftColor: "secondary.main",
            boxShadow: "0 2px 4px rgba(102, 182, 255, 0.1)"
          }),
          "&:hover": {
            cursor: "pointer"
          }
        }}
      >
        <Grid container spacing={1}>
          <Grid item sx={{ width: "auto", flex: 1 }}>
            <Typography>{playerName}</Typography>
            <Typography>{row?.seatName}</Typography>
          </Grid>
          {seatedPairing.isDone && (
            <Grid item sx={{ maxWidth: "auto" }}>
              <Typography sx={{ color: `${color}.main` }}>{`${result}${
                game?.gamePoints !== undefined ? `: ${game.gamePoints}` : ""
              }`}</Typography>
            </Grid>
          )}
          <Grid
            item
            sx={{
              maxWidth: "50px",
              textAlign: "right"
            }}
          >
            <IconButton
              sx={{
                color: "info.contrastText",
                backgroundColor: "info.main",
                "&:hover": { backgroundColor: "info.dark" }
              }}
              onClick={(e) => {
                e.stopPropagation();
                setPairing(seatedPairing);
                setPlayer(row);
                setOptionsAnchorEl6(e.currentTarget);
              }}
            >
              <BCPEllipsisVertical />
            </IconButton>
          </Grid>
        </Grid>
      </Grid>
    );
  } else {
    return (
      <Grid
        item
        xs={12}
        sx={{
          p: 1,
          borderBottom: "1px solid rgba(0, 0, 0, 0.12)",
          ...(isManuallyPlaced && {
            background:
              "linear-gradient(45deg, rgba(102, 182, 255, 0.08) 0%, rgba(102, 182, 255, 0.15) 100%)",
            borderLeft: 4,
            borderLeftColor: "secondary.main",
            boxShadow: "0 2px 4px rgba(102, 182, 255, 0.1)"
          })
        }}
      >
        <Grid container spacing={1}>
          <Grid item sx={{ width: "auto", flex: 1 }}>
            <Typography>{playerName}</Typography>
            <Typography>{row?.seatName}</Typography>
          </Grid>
          {seatedPairing.isDone && (
            <Grid item sx={{ maxWidth: "auto" }}>
              <Typography sx={{ color: `${color}.main` }}>{`${result}${
                game?.gamePoints !== undefined ? `: ${game.gamePoints}` : ""
              }`}</Typography>
            </Grid>
          )}
        </Grid>
      </Grid>
    );
  }
}

export function PlayerResult(props) {
  const { playerNo, pairing, doublesEvent, organize } = props;
  const player = pairing[playerNo];
  const game = pairing[`${playerNo.replace("teamPlayer", "player")}Game`];

  var result = "";
  var color = "";
  if (game?.gameResult >= 2) {
    result = "Win";
    color = "success";
  } else if (game?.gameResult === 1) {
    result = "Draw";
    color = "info";
  } else {
    result = "Loss";
    color = "error";
  }
  if (!doublesEvent && playerNo.startsWith("teamPlayer")) {
    color = "#fff";
  }

  const name = player?.name
    ? player.name
    : player?.id
      ? userDisplayName(
          player?.firstName || player?.user?.firstName,
          player?.lastName || player?.user?.lastName
        )
      : "--------";

  const SolforgeDisplay = () => {
    return (
      <Grid
        container
        spacing={1}
        alignItems="center"
        sx={{
          "& .MuiTypography-root": { fontSize: "16px", m: 0 },
          "& .MuiTypography-root:not(:first-child)": { fontSize: "14px", m: 0 }
        }}
      >
        {playerNo === "player1" && (
          <Grid item sx={{ maxWidth: "40px" }}>
            <Avatar
              alt={name}
              src={player.profileImageUrl}
              sx={{ width: 30, height: 30 }}
            />
          </Grid>
        )}
        <Grid item sx={{ flex: 1 }}>
          <PlayerResultDisplay />
        </Grid>
        {playerNo === "player2" && (
          <Grid item sx={{ maxWidth: "40px", textAlign: "right" }}>
            <Avatar
              alt={name}
              src={player.profileImageUrl}
              sx={{ width: 30, height: 30 }}
            />
          </Grid>
        )}
      </Grid>
    );
  };

  const PlayerResultDisplay = () => {
    return (
      <>
        <Typography>{name}</Typography>
        {game?.gameResult !== undefined && (
          <Typography sx={{ color: `${color}.main` }}>{`${result}${
            game?.gamePoints !== undefined ? `: ${game.gamePoints}` : ""
          }`}</Typography>
        )}
      </>
    );
  };

  if (organize) {
    return getEnvironmentVariable("COMPANY_FLAG") === "solforge" ? (
      <SolforgeDisplay />
    ) : (
      <PlayerResultDisplay />
    );
  } else {
    return (
      <Link
        href={`/game/${
          pairing?.pairingType ? pairing.pairingType.toLowerCase() : "pairing"
        }/${pairing.id}`}
        underline="none"
        sx={{ color: "inherit" }}
      >
        {getEnvironmentVariable("COMPANY_FLAG") === "solforge" ? (
          <SolforgeDisplay />
        ) : (
          <PlayerResultDisplay />
        )}
      </Link>
    );
  }
}
